// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.page-container[data-v-3fba94c0]{\n  margin: 40px 57px 50px 32px;\n}\n.page-container .page-title[data-v-3fba94c0] {\n  padding-bottom: 24px;\n  border-bottom: 1px solid #D3D7DF;\n}\n", ""]);
// Exports
module.exports = exports;
